import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { loadResultsSummary } from "@/lib/results-seo";

export const Route = createFileRoute("/")({
  loader: ({ context }) => loadResultsSummary(context.queryClient, 0),
  head: ({ loaderData }) => {
    const s = loaderData ?? { dateLabel: "", tica: "", nica: "" };
    const title = `Tiempos Hoy ${s.dateLabel} EN VIVO: Diaria Nica y Nuevos Tiempos Tica`;
    const description = `✅ Resultados en vivo ${s.dateLabel}. Nuevos Tiempos Costa Rica: ${s.tica || "1pm, 4:30pm y 7:30pm"}. Loto Diaria Nicaragua: ${s.nica || "11am, 3pm y 9pm; 6pm fines de semana"}. Actualizado al instante tras cada sorteo.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://tiemposhoy.com/" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: "https://tiemposhoy.com/" }],
    };
  },
  component: Index,
});
